import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslations } from "next-intl";
import { UiLegacy } from "@silvertours/front-legacy-shared";
import { Ui } from "@silvertours/front-shared";
import { RatingGroups } from "./RatingGroups";
import { ReviewContainer, ReviewFooter, QuoteContainer, ArrowUpIcon } from "./Reviews.styles";
import { ReviewHeader } from "./ReviewHeader";
import { useReviewItem } from "./useReviewItem";
var ExpandedReviewItem = function(props) {
    var t = useTranslations("features.trustLegacy.feedback.reviewItem");
    var providerQuote = props.providerQuote, ratingGroups = props.ratingGroups, onClose = props.onClose, siteQuote = props.siteQuote;
    var ref = useReviewItem(props), header = ref.header, host = ref.host, providersQuoteTitleLabel = ref.providersQuoteTitleLabel, reviewerLabel = ref.reviewerLabel, siteQuoteTitleLabel = ref.siteQuoteTitleLabel;
    return /*#__PURE__*/ _jsxs(ReviewContainer, {
        children: [
            /*#__PURE__*/ _jsx(ReviewHeader, _object_spread({}, header)),
            /*#__PURE__*/ _jsxs(QuoteContainer, {
                children: [
                    /*#__PURE__*/ _jsx(UiLegacy.PlainText, {
                        children: /*#__PURE__*/ _jsx("b", {
                            children: siteQuoteTitleLabel
                        })
                    }),
                    /*#__PURE__*/ _jsx(UiLegacy.Quote, {
                        children: siteQuote
                    }),
                    /*#__PURE__*/ _jsx(UiLegacy.PlainText, {
                        children: /*#__PURE__*/ _jsx("b", {
                            children: providersQuoteTitleLabel
                        })
                    }),
                    /*#__PURE__*/ _jsx(UiLegacy.Quote, {
                        children: providerQuote.quote
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(RatingGroups, {
                ratingGroups: ratingGroups,
                providerQuote: providerQuote,
                host: host
            }),
            /*#__PURE__*/ _jsxs(ReviewFooter, {
                children: [
                    /*#__PURE__*/ _jsx(UiLegacy.TinyText, {
                        children: reviewerLabel
                    }),
                    /*#__PURE__*/ _jsxs(Ui.TextLink, {
                        as: "button",
                        onClick: onClose,
                        children: [
                            t("readLess"),
                            /*#__PURE__*/ _jsx(ArrowUpIcon, {})
                        ]
                    })
                ]
            })
        ]
    });
};
export { ExpandedReviewItem };
